module.exports = __webpack_public_path__ + "static/media/modeloApuracao.7920f9c5.xlsx";